import React from 'react'
import ReactDOM from 'react-dom'
import { browserHistory, IndexRoute, Router, Route } from 'react-router'
import { About, App, Contact, NotFound, Press, Trailer, Theaters } from './components'
import './index.css'

function Index () {
  return (<div />)
}

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={Index} />
      <Route path="about" component={About} />
      <Route path="theaters" component={Theaters} />
      <Route path="contact" component={Contact} />
      <Route path="press" component={Press} />
      <Route path="trailer" component={Trailer} />
      <Route path="*" component={NotFound} />
    </Route>
  </Router>,
  document.querySelector('main')
)



// WEBPACK FOOTER //
// ./src/index.js